import { Separator } from '@betterment/samba-react';

import { EmergencyFundForm } from './EmergencyFundForm';
import { EmergencyFundTargetSection } from './EmergencyFundTargetSection';

import { EmergencyFundSettingsPurpose } from '../../../data';

type Props = {
  purpose: EmergencyFundSettingsPurpose;
};

export const EmergencyFundSettings = ({ purpose }: Props) => {
  return (
    <>
      <EmergencyFundForm purpose={purpose} />
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <EmergencyFundTargetSection purpose={purpose} />
    </>
  );
};
